'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _angular = require('angular');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _find2 = require('lodash/find');

var _find3 = _interopRequireDefault(_find2);

var _d = require('d3');

var d3 = _interopRequireWildcard(_d);

var _nvd = require('nvd3');

var _nvd2 = _interopRequireDefault(_nvd);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cbGraph = function cbGraph() {
    (0, _classCallCheck3.default)(this, cbGraph);

    this.template = '<svg class="cb-graph__svg"></svg>';
    this.restrict = 'E';
    this.scope = {
        data: '='
    };
    this.link = function ($scope, $element) {

        var localeFormatter = d3.locale({
            'decimal': ',',
            'thousands': '.',
            'grouping': [3],
            'currency': ['€', ''],
            'dateTime': '%a %b %e %X %Y',
            'date': '%d-%m-%Y',
            'time': '%H:%M:%S',
            'periods': ['AM', 'PM'],
            'days': ['Zondag', 'Maandag', 'Dinsdag', 'Woensdag', 'Donderdag', 'Vrijdag', 'Zaterdag'],
            'shortDays': ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
            'months': ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'],
            'shortMonths': ['Jan', 'Feb', 'Mrt', 'Apr', 'Mei', 'Jun', 'Jul', 'Aug', 'Sept', 'Okt', 'Nov', 'Dec']
        });
        d3.time.format = localeFormatter.timeFormat;
        d3.format = localeFormatter.numberFormat;

        var draw = function draw() {

            var chart = _nvd2.default.models.multiChart().margin({ top: 50, right: 30, bottom: 50, left: 65 }).x(function (d) {
                return d[0];
            }).y(function (d) {
                return d[1];
            });

            chart.xAxis.tickFormat(function (d) {
                return formatValueByType($scope.data[0].xType, d, 0, 'MMM \'YY');
            }).tickValues(function (d) {
                return d[0].values.map(function (val) {
                    return formatValueByType($scope.data[0].xType, val[0], 2);
                });
            }).tickPadding(10).showMaxMin(false);

            chart.yAxis1.tickFormat(function (d) {
                return formatValueByType($scope.data[0].yType, d, 0);
            }).showMaxMin(true).tickPadding(10);

            chart.yAxis2.tickFormat(function (d) {
                return formatValueByType($scope.data[0].yType, d, 0);
            }).showMaxMin(true).tickPadding(10);

            chart.legend.margin({ top: 5, right: -10, left: 0, bottom: 20 });

            // chart.bars1 // Todo: Moet nog gefixt worden voor staafdiagrammen. Uitlijning met ticks klopt niet.
            //     .x((d,i) => { return i; })
            //     .xScale(d3.scale.ordinal().rangeBands([0, 732]), .1)
            //     .groupSpacing(0.2);

            d3.select($element.find('svg')[0]).datum($scope.data).transition().duration(0).call(chart);

            chart.tooltip.contentGenerator(function (d) {
                var key = d.series[0].key;
                var graphData = (0, _find3.default)($scope.data, { 'key': key });
                var tooltipTitle = formatValueByType(graphData.xType, d.value, 0, 'MMMM');
                var html = '<div class="nvd3-tooltip hidden-xs"><strong>' + tooltipTitle + '</strong><br>';

                d.series.forEach(function (elem) {
                    var tooltipValue = formatValueByType(graphData.yType, elem.value, 2);
                    html += '<span>' + elem.key + '</span>: ';
                    html += '<span>' + tooltipValue + '</span>';
                });
                html += '</div>';
                return html;
            });

            _nvd2.default.utils.windowResize(chart.update);

            return chart;
        };

        $scope.$on('graph:repaint', function () {
            draw();
        });

        $scope.$watch('data', function (newValue) {
            if ((0, _angular.isDefined)(newValue)) {
                draw();
            }
        }, true);

        var formatValueByType = function formatValueByType(type, value, decimals, dateFormat) {
            var decimalFormat = ',.' + decimals + 'f';

            switch (type) {
                case 'euro':
                    return '€ ' + d3.format(decimalFormat)(value);
                    break;
                case 'percentage':
                    return d3.format('.1%')(value / 100);
                    break;
                case 'date':
                    return dateFormat ? (0, _moment2.default)(value).format(dateFormat) : (0, _moment2.default)(value);
                    break;
                case 'number':
                    return value;
                    break;
                default:
                    return value;
                    break;
            }
        };
    };
};

exports.default = cbGraph;


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/graph/graph.directive.js
// module id = 805
// module chunks = 0